import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const LoginFooterContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-end;
  left: -1px;
  bottom: 0px;
  background: #f1f2f3;

  p {
    color: #4f4f4f;
    font-family: Inter, sans-serif;
  }
`;

export const LoginFooterTop = styled.div`
  background-color: #cacbcc;
  flex-shrink: 0;
  align-self: stretch;

  p {
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0em;
    line-height: 1.5rem;
    text-align: center;
  }
`;

export const LoginFooterBottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  align-self: stretch;

  p {
    padding: ${ThemePrisma.spacing.large};
    max-width: 80%;
    font-size: 0.75rem;
    font-weight: 400;
    letter-spacing: 0em;
    line-height: 1rem;

    @media (min-width: 1365px) {
      padding: ${ThemePrisma.spacing.xlarge};
    }
  }
`;
